import React from 'react'
import EducationPage from "./education"

const Education = () => <EducationPage />

export default Education
